module.exports = __webpack_public_path__ + "img/business-2.4186fec8.png";